import { Center, Loader } from "@mantine/core";
import { FC } from "react";

const ContentLoader: FC = () => (
  <Center style={{ minHeight: "60vh", width: "100%" }}>
    <Loader size="lg" />
  </Center>
);

export default ContentLoader;
